import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import styles from "../productPageStyle.js";
import SectionHead from "./SectionHead.js";

const useStyles = makeStyles(styles);

/**
 * B-01 §28.3 item 4 in full (docsSearch → /claim-check), and item 5 only
 * partly: this links the 04 policy document, plus the B-01 manual and the fee
 * schedule for context. Item 5 as specified also calls for M-04 and C-04 —
 * those documents do not exist in public/ yet, so they are not linked here.
 * See the spec's open items.
 *
 * The PDF paths are the rewrites already declared in vercel.json — link
 * through those, not at the raw filenames, so a document revision does not
 * strand this page on an old file.
 */
export default function DocumentsSection({ t, num }) {
  const classes = useStyles();

  const documents = [
    { title: t.docsRegulation, kind: t.docsRegulationKind, url: "/ugc-reg-hu" },
    { title: t.docsManual, kind: t.docsManualKind, url: "/ugc-bm-hu" },
    { title: t.docsPrice, kind: t.docsPriceKind, url: "/ugc-price-hu" },
    { title: t.docsSearch, kind: t.docsSearchKind, url: "/claim-check" },
  ];

  return (
    <section id="section-documents" className={classes.section}>
      <SectionHead num={num} title={t.docsTitle} />
      <p className={classes.paragraphMuted}>{t.docsIntro}</p>

      <div className={classes.docList}>
        {documents.map((doc) => (
          <a
            className={classes.docRow}
            key={doc.url}
            href={doc.url}
            target="_blank"
            rel="noopener noreferrer"
          >
            <div className={classes.docCell}>
              <span className={classes.docTitle}>{doc.title}</span>
              <span className={classes.docKind}>{doc.kind}</span>
            </div>
            <span className={classes.docOpen}>
              <span className={classes.docOpenText}>{t.docsOpen}</span>
              <svg
                width="15"
                height="15"
                viewBox="0 0 16 16"
                fill="none"
                aria-hidden="true"
              >
                <path
                  d="M4.5 11.5 11.5 4.5M6 4.5h5.5V10"
                  stroke="#1B5E20"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </span>
          </a>
        ))}
      </div>
    </section>
  );
}
